var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8905 11.4736L13.5155 16.6256L11.1095 14.3195C10.7984 14.0213 10.2944 14.0213 9.98331 14.3195C9.67223 14.6177 9.67223 15.1008 9.98331 15.3989L12.9524 18.2448C13.1073 18.3933 13.312 18.4688 13.5155 18.4688C13.7189 18.4688 13.9224 18.3945 14.0786 18.2448L20.0167 12.5531C20.3278 12.2549 20.3278 11.7718 20.0167 11.4736C19.7056 11.1755 19.2016 11.1755 18.8905 11.4736Z",
    fill: "#3E7E96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionCheckedIcon);
export default __webpack_public_path__ + "static/media/subscriptionCheckedIcon.0eef61588883aa48ce6e6d5b2172800f.svg";
export { ForwardRef as ReactComponent };